import * as types from './types';

const sendUnreadLeadsMessagge = (postingIds, customMessage) => ({
  type: types.SEND_UNREAD_LEADS_MSG,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/posting/leads/savePostingIdsToCheckLeads',
    method: 'POST',
    body: { postingIds, customMessage }
  }
});

const setShowUnreadLeadsModal = (showUnreadLeadsModal, postingIds, comesFromArchive) => ({
  type: types.SHOW_UNREAD_LEADS_MODAL,
  payload: {
    showUnreadLeadsModal,
    postingIds,
    comesFromArchive
  }
});

const getUnreadLeads = postingIds => ({
  type: types.HAS_UNREAD_LEADS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/posting/leads/hasUnreadLeads',
    method: 'GET',
    query: { postingIds }
  }
});

const resetUnreadLeads = () => ({
  type: types.RESET_UNREAD_LEADS
});

export { sendUnreadLeadsMessagge, setShowUnreadLeadsModal, getUnreadLeads, resetUnreadLeads };
